<!-- eslint-disable @typescript-eslint/no-explicit-any -->
<script setup lang="ts">
import { ref, watch } from 'vue';

import { useComponentState } from '#public_ts/composables';

import type { LowerPaneDetailsBuilder } from './lower-pane-details';
import TabPane from './tab/tab-pane.vue';

const props = defineProps<{
    row?: any;
    builder?: LowerPaneDetailsBuilder<any>;
    size?: 'normal' | 'wide';
}>();
const state = useComponentState({ id: 'LowerPaneDetails', initialUpdate: true });
const details = ref<[string, string][]>([]);

watch(() => props.row, () => {
    state.update();
});

state.onUpdate(() => {
    if(props.row && props.builder) {
        details.value = props.builder(props.row);
    }
});
</script>

<template>
    <TabPane title="Informazioni Generali" initially-active @toggle="(active) => { state.freeze(!active); }">
        <dl class="dl-horizontal">
            <template v-for="([title, value]) in details" :key="title">
                <dt :class="(props.size === 'wide') ? 'detail-wide' : ''">
                    {{ title }}
                </dt>
                <dd :class="(props.size === 'wide') ? 'detail-wide' : ''">
                    {{ value }}
                </dd>
            </template>
        </dl>
    </TabPane>
</template>

<style lang="css">
dt.detail-wide {
    width: 250px;
}
dd.detail-wide {
    margin-left: 270px;
}
</style>
